import { Button, Skeleton, Table } from "antd";
import React, { useEffect, useState } from "react";
import Dashboard from "../Layout/Dashboard";
import { getProducts } from "../../actions/products";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { formatDate } from "../../utils/Utils";

const Products = ({ currentUser, storeCurrency }) => {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const history = useNavigate();
  const data = useSelector((state) => state.products);

  useEffect(() => {
    setLoading(true);
    dispatch(getProducts(currentUser.store));
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  const columns = [
    {
      key: 1,
      title: "Product",
      render: (_, record) => (
        <div className="flex items-center">
          <div className="flex-shrink-0 h-10 w-10">
            <img
              src={record?.image}
              alt="Product"
              className="h-10 w-10 rounded-full"
            />
          </div>
          <div className="ml-4">{record?.name}</div>
        </div>
      ),
    },
    {
      key: 2,
      title: "Price",
      dataIndex: "price",
      render: (_, record) => (
        <p>
          {storeCurrency} {record?.price}
        </p>
      ),
    },
    {
      key: 3,
      title: "Brand",
      dataIndex: "brand",
    },
    {
      key: 4,
      title: "SKU",
      dataIndex: "sku",
    },
    {
      key: 5,
      title: "Category",
      render: (_, record) => record?.category?.name,
    },
    {
      key: 6,
      title: "Updated At",
      render: (_, record) => <p>{formatDate(record?.updatedAt)}</p>,
    },
    {
      key: 7,
      title: "Created At",
      render: (_, record) => <p>{formatDate(record?.createdAt)}</p>,
    },
  ];

  const onRowClick = (id) => {
    history(`/product/${id}`);
  };

  return (
    <Dashboard title="Products">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl m-0 font-bold">Products</h2>
        <Button type="primary" href="/product/new" htmlType="submit">
          Add Product
        </Button>
      </div>
      <div className="bg-white shadow p-4 my-4">
        <Skeleton loading={loading}>
          <Table
            className="cursor-pointer"
            columns={columns}
            scroll={{
              x: 1000,
            }}
            dataSource={data}
            rowKey={(record) => record?._id}
            onRow={(record) => {
              return {
                onClick: () => {
                  onRowClick(record?._id);
                },
              };
            }}
          />
        </Skeleton>
      </div>
    </Dashboard>
  );
};

export default Products;
